import { useDataGridConfig, filterRows } from '@/hooks/useDataGridConfig'
import { useGetGPs } from '@/services/gp'
import { Box, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import DataGridTable from '@/components/shared/DataGridTable'
import type { GridColDef } from '@mui/x-data-grid'
import type { GP } from '@/types/gp'

const columns: GridColDef<GP>[] = [
  { field: 'hash', headerName: 'hash', width: 90 },
  { field: 'name', headerName: 'Name', width: 200, flex: 1 },
  { field: 'email', headerName: 'Email', width: 180, flex: 1 },
  { field: 'contact_number', headerName: 'Contact Number', width: 180 },
  { field: 'postcode', headerName: 'Postcode', width: 150 },
  { field: 'address_line_1', headerName: 'Address Line 1', width: 250 },
  { field: 'address_line_2', headerName: 'Address Line 2', width: 250 },
  { field: 'address_line_3', headerName: 'Address Line 3', width: 250 },
  { field: 'address_line_4', headerName: 'Address Line 4', width: 250 },
  { field: 'county', headerName: 'County', width: 150 },
  {
    field: 'created_at',
    headerName: 'Created At',
    minWidth: 250,
    flex: 0.6,
    type: 'dateTime',
    valueGetter: (_value, row) => new Date(row.created_at)
  }
]

export default function GPSPage() {
  const config = useDataGridConfig({ tableId: 'gps', syncToUrl: true })
  const { data, isLoading, isFetching } = useGetGPs()
  const navigate = useNavigate()

  const filteredData = filterRows(data ?? [], config.filters)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Typography variant='pageTitle' component='h1' sx={{ fontSize: '24px' }}>
        GPs
      </Typography>
      <DataGridTable
        {...config}
        filterMode='client'
        rows={filteredData}
        getRowId={el => el.hash}
        columns={columns}
        loading={isLoading || isFetching}
        rowSelection={false}
        onRowClick={params =>
          navigate(`/gps/${params.id}`, {
            state: { backLabel: 'Back to GPs list', fallbackPath: '/gps' }
          })
        }
      />
    </Box>
  )
}
